var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgVerticalScrollArrow = function SvgVerticalScrollArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.352 1.519v11.963M9.339 9.494 5.35 13.482 1.364 9.494",
    stroke: "#21262C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
};

export default SvgVerticalScrollArrow;